import type { ClientAccount } from "../../clients/types/clients-api.types";
import { isCryptoWalletCurrency } from "../../confirmations/constants/currencies.config";

export function paymentAccountSelectLabel(account: ClientAccount): string {
  const bank = (account.bank_name ?? "").trim() || "—";
  const cur = (account.currency ?? "").trim() || "—";
  const alias = (account.alias ?? "").trim();
  const base = isCryptoWalletCurrency(cur)
    ? `Red (${bank}), Moneda (${cur})`
    : `Banco (${bank}), Moneda (${cur})`;
  return alias ? `${base} — ${alias}` : base;
}
